module.exports = __webpack_public_path__ + "img/henkel-natco.29cfc6a2.jpg";